<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 840px; dislay: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <Finish
        :ifImage="false"
        :imgUrl="imgUrl"
        :message="score"
        :showbtn="true"
        @nextRoute="nextRouteFunction()"
      />
    </template>
  </div>
</template>

<script>
import Finish from '@/components/elements/Finish';
import {mapGetters} from 'vuex';
import LoadingMDL from '@/components/loading/LoadingMDL';
import TEMPLATE from '../../TEMPLATE.vue';

export default {
  name: 'MF01',
  components: {Finish, LoadingMDL},
  props: {
    TEMPLATE,
  },
  data() {
    return {
      text: '00/50',
      imgUrl:
        'https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-image-512.png',
      currentRoute: '',
      loading: true,
      navigate: [],
      score: String,
      templateData: [],
      condition: [],
      startTime: this.$helpers.getDateFormat(),
      code: '',
      section: '',
    };
  },
  methods: {
    nextRouteFunction: function () {
      this.loading = true;
      this.$store.dispatch('template/commitUserProgressChinese2', {
        // code: "605418cb883ae722ba1b0c5f",
        code: this.code,
        codeTemplate: this.templateData.templateData.codeTemplate,
        contentId: this.templateData.criteria._id,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
        chapter:
          this.templateData.chapter == undefined
            ? null
            : this.templateData.chapter,
        topic: this.templateData.topicPosition,
      });
    },
  },
  computed: {
    ...mapGetters({
      getTemplateAndProgress: 'template/getTemplateAndProgress',
      getResponseStatus: 'template/getResponseStatus',
    }),
  },
  watch: {
    getTemplateAndProgress: function (value) {
      let userScore = String(value.calcualteScore.score).padStart(2, '0');
      let maxScore = String(value.calcualteScore.from).padStart(2, '0');
      this.score = userScore + '/' + maxScore;
      if (value.criteria.condition.criteriaType.length != 0) {
        this.condition.push({
          criteria: value.criteria.condition.criteriaType[0]._id,
          val: value.criteria.condition.criteriaType[0].val,
        });
      }
      this.navigate = value.templateData.navigate;
      this.templateData = value;
      this.loading = false;
    },
    getResponseStatus: async function (value) {
      if (value.status == 200) {
        let route = this.navigate.next.action.split('-');
        this.$router.push('/' + route[0] + '/' + route[1]);
      }
    },
  },
  created() {
    this.currentRoute = this.$route.name + '-' + this.$route.params.id;
    this.courseData = this.$store.getters['necessary/getLerningCourse'];
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection'];
    console.log(this.section);
  },
  mounted() {
    let payload = {
      templateCode: this.currentRoute,
      // code: "605418cb883ae722ba1b0c5f",
      code: this.code,
      // section: "testing",
      section: this.section,
      calculate_score: true,
    };
    this.$store.dispatch('template/fetchTemplateAndProgress', payload);
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss"></style>
